import StudentDemographics from './StudentDemographics.component';

export default StudentDemographics;
